module.exports = __webpack_public_path__ + "img/management-philosophy.f929ce20.png";